const lib = {

 calculateBrightness:(red, green, blue)=>{
        return Math.sqrt(
            (red * red) * 0.299 +
            (green * green) * 0.587 +
            (blue * blue) * 0.114
        );
    },

   shuffle:(o)=> {
        for (let j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[
                j] = x);
        return o;
    },
    logSlider:(position)=>{
      
      
        
       
       
        return Math.exp(position/2000)

    },
    Pixel: (r, g, b, a) => {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
        return this
    },


    unwrap:(data)=> {
        unwrapped_list = [];

        for (var i = 0; i < data.length; i++) {
            unwrapped_list.push(data[i].r);
            unwrapped_list.push(data[i].g);
            unwrapped_list.push(data[i].b);
            unwrapped_list.push(data[i].a);
        }

        return unwrapped_list
    },
     obj_list :(flat_array)=> {
        const new_obj = [];

        for (let i = 0; i < flat_array.length; i += 4) {
            new_obj.push( {
                r:  flat_array[i],
                g: flat_array[i + 1],
                b:   flat_array[i + 2],
                a:flat_array[i + 3]
            })
        }

        return new_obj
    },


    bubblesort: (list, channel) => {
        list.sort( (a, b) =>{
            if (a[channel] > b[channel]) {
                return 1;
            }

            if (a[channel] < b[channel]) {
                return -1;
            }

            return 0;
        });

        return list
    },

    channel_shuffle: (list, f1, f2, f3) => {

        for (var i = 0; i < list.length - 1; i++) {

            list[i].b += 50;

            //comparison
            if (list[i].b > list[i].g) {
                list[i].r = list[i].b;
            } else {
                list[i].b = list[i].g;
            }




        }
        return list
    },

    sort_some: (list, dark, light) => {
        var len = list.length;
        for (var i = 0; i < len - 1; i++) {
            var bright = lib.brightness(list[i].r, list[i].g, list[i].b);
            if (bright <= 100) {
                light[i] = 1;
            }
            if (bright >= 200) {
                dark[i] = 1;
            }
        }
    },

    brightness: (r, g, b) => {

        r = (r * r * 0.241);
        g = (g * g * 0.691);
        b = (b * b * 0.068);
        return Math.floor(Math.sqrt(r + g + b));

    },

    channel_range: (list, width, f1, f2, f3) => {
        //ranges
        for (let i = 0; i < list.length - 1; i++) {
            if ((list[i].g > 100) && (list[i].b > 200)) {

                if (i + 5 < list.length) {
                    list[i + 5].r = f1;
                    list[i + 5].g = f2;
                    list[i + 5].b = f3;
                }

            }
        }
        return list
    },

    channel_range1: (list, width, f1, f2, f3,force=5) => {
        //ranges
        for (let i = 0; i < list.length - 1; i++) {
            if ((list[i].g > 50) && (list[i].b > 100)) {

                if (i + force < list.length) {
                    list[i + force].r = f1;
                    list[i + force].g = f2;
                    list[i + force].b = f3;
                }

            }
        }
        return list
    },

    channel_range2: (list, width, f1, f2, f3) => {
        //ranges
        for (let i = 0; i < list.length - 1; i++) {
            if ((list[i].g > 100) && (list[i].b > 200)) {

                if (i + 7 < list.length) {
                    list[i + 7].r = f1;
                    list[i + 7].g = f2;
                    list[i + 7].b = f3;
                }

            }
        }
        return list
    }

    , channel_range3: (list, width, f1, f2, f3) => {
        //ranges
        for (var i = 0; i < list.length - 1; i++) {
            if ((list[i].r > 200) && (list[i].b > 100)) {

                if (i + 9 < list.length) {
                    list[i + 9].r = f1;
                    list[i + 9].g = f2;
                    list[i + 0].b = f3;
                }

            }
        }
        return list
    }

    , channel_range4: (list, width, f1, f2, f3) => {
        //ranges
        for (var i = 0; i < list.length - 1; i++) {
            //grayscaling
            var avg = Math.floor((list[i].r + list[i].g + list[i].b) / 3);
            if (avg < list[i].r) {
                list[i].r = (f1 + f2 + f3) / 255;

            }
        }
        return list
    }

    , channel_range5: (list, width, f1, f2, f3) => {
        //ranges
        for (var i = 0; i < list.length - 1; i++) {
            //grayscaling
            var avg = Math.floor((list[i].r + list[i].g + list[i].b) / 3);
            if (avg < list[i].r) {
                list[i].r = avg;
            }
        }
        return list
    }

    , channel_range6: (list, width, f1, f2, f3) => {
        var dark = {};
        var light = {};
        lib.sort_some(list, dark, light);
        let len=list.length
        for(let i =0;i<list.length;i++){
            if (i in light) {

                list[i].r = 0;
                if (i - 15 > len) {
                    list[i - 15].b = list[i + 3].b + 35;
                }
            } else if (i in dark) {
                list[i].g = f1;
                list[i].r = f2;
                list[i].b += f3;
                //shift pixels
                if (i - 30 < len) {
                    list[i - 30] = list[i];
                }
            }
    
        }
      
        return list
    }


    , randInt: (a, b) => {
        return Math.floor(Math.random() * (b - a) + a);
    }

    , shufflearray: (a) => {
        var j, x, i;
        for (i = a.length; i; i--) {
            j = Math.floor(Math.random() * i);
            x = a[i - 1];
            a[i - 1] = a[j];
            a[j] = x;
        }
    }

    , RandomNumber: () => {
        var random = Math.floor(Math.random() * 199) - 98;
        return random;
    }


}

module.exports = lib